<template>
    <div class="document-field-config-viewer" :style="computedStyle">
        [{{ item.fieldName || 'campo' }}]
    </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import * as OM from '@/model';

@Options({})
export default class DocumentFieldConfigViewer extends Vue {
    @Prop() item: OM.DocumentFieldConfig;

    get computedStyle() {
        return {
            fontSize: (this.item.fontSize || 14) + 'px',
            fontFamily: this.item.fontFamily || 'Arial',
            color: this.item.color || '#0066cc',
            fontWeight: this.item.fontWeight || 'normal',
            textAlign: this.item.textAlign || 'left',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            border: '1px dashed #0066cc',
            padding: '1px 4px',
            minWidth: '20px',
            minHeight: '16px',
        };
    }
}
</script>
